export const IndicatorUnitFilter = () => indicator => {
  let output: string | number = '-';
  if (indicator.type === 'STATIC' || indicator.type === 'EXTERNAL') {
    output = indicator.value;
  } else if (!isNaN(indicator.value) && isFinite(indicator.value)) {
    let s;
    let m;
    if (indicator.type === 'NORMAL') {
      if (
        indicator.indicator.search(/ta_/i) !== -1 ||
        indicator.indicator.search(/_wt/i) !== -1 ||
        indicator.indicator.search(/_tmax/i) !== -1
      ) {
        s = Math.round((indicator.value * 0.001) % 60);
        m = Math.floor((indicator.value * 0.001) / 60);
        if (m === 0) {
          output = ('0' + s).slice(-2) + 's';
        } else {
          output = ('0' + m).slice(-2) + 'm' + ('0' + s).slice(-2) + 's';
        }
      } else if (indicator.indicator.search(/rate_/i) !== -1) {
        output = indicator.value + '%';
      } else {
        output = indicator.value;
      }
    } else if (indicator.type === 'CUSTOM' && indicator.properties != null) {
      let ta = true;
      let rate = true;
      indicator.properties.forEach(property => {
        if (typeof property === 'object' && isNaN(property.indicator)) {
          if (
            property.indicator.search(/ta_/i) === -1 &&
            property.indicator.search(/_wt/i) === -1 &&
            property.indicator.search(/_tmax/i) === -1
          ) {
            ta = false;
          }
          if (property.indicator.search(/rate_/i) === -1) {
            rate = false;
          }
        }
      });
      if (ta) {
        s = Math.round((indicator.value * 0.001) % 60);
        m = Math.floor((indicator.value * 0.001) / 60);
        if (m === 0) {
          output = ('0' + s).slice(-2) + 's';
        } else {
          output = ('0' + m).slice(-2) + 'm' + ('0' + s).slice(-2) + 's';
        }
      } else if (rate) {
        output = indicator.value + '%';
      } else {
        output = Math.round(indicator.value * 100) / 100;
      }
    }
  } else if (typeof indicator.value === 'string') {
    output = indicator.value;
  }
  // Replace '-' by 0 for LBP
  if (output === '-') {
    output = 0;
  }
  if (indicator.prefix !== '' && indicator.prefix != null) {
    output = indicator.prefix + ' ' + output;
  }
  if (indicator.suffix !== '' && indicator.suffix != null) {
    output = output + ' ' + indicator.suffix;
  }
  return output;
};

export default 'indicatorUnit';
